module.exports = __webpack_public_path__ + "img/Sezione_Industria.35af41e2.jpg";